module.exports = __webpack_public_path__ + "static/searcher-939d6db39dcaab05b72b4c0b32cb7d2b.svg";